import styled from 'styled-components';

const GoTop = styled.div<{ isTablet: boolean, isMobile: boolean }>`
  position: fixed;
  bottom: ${(p) => (p.isMobile ? '22px' : p.isTablet ? '60px' : '130px')};
  right: ${(p) => (p.isMobile ? '15px' : p.isTablet ? '60px' : '122px')};
  width: 80px;
  height: 80px;
  background-color: ${(p) => p.theme.colors.secondary400};
  border: 0;
  border-radius: 15px 15px 15px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  z-index: 1;
  padding-top: 43px;
  font-family: 'Roboto', sans-serif;
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  line-height: 23px;
  color: ${(p) => p.theme.colors.light};

  :hover {
    filter: brightness(1.1);
  }

  :focus-visible {
    outline: 3px solid ${(p) => p.theme.colors.primary500};
    outline-offset: 3px;
  }

  ::after {
    content: '';
    background-image: url('/images/index/up-arrow.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    width: 56px;
    height: 56px;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
 
const ChatBox = styled.a<{ isTablet: boolean, isMobile: boolean }>`
  display: block;
  text-align: center;
  cursor: pointer;
  position: fixed;
  z-index: 1;
  bottom: ${(p) => (p.isMobile ? '112px' : p.isTablet ? '150px' : '220px')};
  right: ${(p) => (p.isMobile ? '15px' : p.isTablet ? '60px' : '122px')};
  background: ${(p) => p.theme.colors.primary500};
  color: ${(p) => p.theme.colors.light};
  padding: 5px 10px;
  border-radius: 15px 15px 15px 0px;
  width: 80px;
  font-size: 16px;

  p {
    margin-bottom: 2.5px;
  }
`

export { GoTop, ChatBox };
